import { produce } from "immer";
import { merge } from "lodash";
import React, { createContext, useContext } from "react";

import useHashMemo from "../../hooks/useHashMemo";

import { MarksOptions } from "./processors/marks";

export type RichContentDisplayOptions = {
  marks?: MarksOptions;
  sanitize?: boolean;
  baseHref?: string;
  showAdditionalContext?: boolean;
};

export type RichContentDisplayOptionsProducer = (
  options: RichContentDisplayOptions,
) => RichContentDisplayOptions | void;

const RichContentDisplayOptionsContext =
  createContext<RichContentDisplayOptions>({});

//
// @todo: this "merge" logic is repeated from RichContentOptionsProvider
// Can we refactor something generally useful?
//
export const useRichContentDisplayOptions = (
  options?: RichContentDisplayOptions | RichContentDisplayOptionsProducer,
) => {
  const parentOptions = useContext(RichContentDisplayOptionsContext);

  let mergedOptions: RichContentDisplayOptions;
  if (typeof options == "function") {
    mergedOptions = produce(parentOptions, options);
  } else if (options != null) {
    mergedOptions = merge({}, parentOptions, options);
  } else {
    mergedOptions = parentOptions;
  }

  return useHashMemo(mergedOptions);
};

export const RichContentDisplayOptionsProvider: React.FC<
  React.PropsWithChildren<{
    options?: RichContentDisplayOptions | RichContentDisplayOptionsProducer;
  }>
> = ({ children, ...props }) => {
  const options = useRichContentDisplayOptions(props.options);

  return (
    <RichContentDisplayOptionsContext.Provider value={options}>
      {children}
    </RichContentDisplayOptionsContext.Provider>
  );
};
